import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import { DestinationCard, SectionHeader } from '@/shared/components/ui';
import { useDestinations } from '@/features/destinations/hooks/useDestinations';

const FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=800&q=80';

export function DestinationsPage() {
  const { data } = useDestinations();

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: { xs: 3, md: 5 } }}>
      <Container maxWidth="lg">
        <SectionHeader
          eyebrow="Where to next"
          title="Destinations"
          subtitle="Explore cities and regions with passionate local guides."
        />
        <Grid container spacing={3}>
          {data?.data.map((destination) => (
            <Grid key={destination._id} size={{ xs: 12, sm: 6, md: 4 }}>
              <DestinationCard
                destination={{
                  id: destination._id,
                  name: destination.name,
                  image: destination.imageUrl || FALLBACK_IMAGE,
                  guideCount: 0,
                  slug: destination.name.toLowerCase().replace(/\s+/g, '-'),
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
